import Vue from 'vue'
import App from './App'
// 路由
import router from './router/index.js';
// vuex
import store from './store/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import constant from './constant/constant'
import {eduNoticeBox} from './components/common/eduUI';
import StarRating from 'vue-dynamic-star-rating'
import '@/permission' // permission control
import dayjs from "dayjs";
// 导入animate.css
import animate from 'animate.css'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN';

Vue.prototype.dayjs = dayjs;

Vue.use(eduNoticeBox)

Vue.use(animate)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('star-rating', StarRating);
Vue.prototype.constant = constant;
var VueTouch = require('vue-touch');
Vue.use(VueTouch, {name: 'v-touch'});

Vue.use(VueI18n);
const i18n = new VueI18n({locale: 'zh_CN'});

Vue.use(VeeValidate, {
  i18n, i18nRootKey: 'validation', dictionary: {
    zh_CN: {
      messages: {
        required: (field) => '请输入' + field,
        numeric: '请输入数字',
        decimal: (field, param) => field + '的小数位必须小于等于' + param[0] + '',
        max: (field, param) => field + '必须小于' + param[0] + '字符',
        min: (field, param) => field + '必须大于' + param[0] + '字符',
        max_value: (field, param) => field + '必须小于' + param[0],
        min_value: (field, param) => field + '必须大于' + param[0],
        confirmed: (field, param) => field + "和" + param[0] + "不一致"
      }
    }
  },
  events: '',
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fieldBags',
});

if (localStorage.getItem('user-info')) {
  localStorage.removeItem('user-info')
}
Vue.prototype.$bus = new Vue()

export var vm = new Vue({
  el: '#app', router, store, components: {App}, template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js